import { render, staticRenderFns } from "./RateUs.vue?vue&type=template&id=fd7a21be&scoped=true&"
import script from "./RateUs.vue?vue&type=script&lang=js&"
export * from "./RateUs.vue?vue&type=script&lang=js&"
import style0 from "./RateUs.vue?vue&type=style&index=0&id=fd7a21be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7a21be",
  null
  
)

export default component.exports